import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PlayIcon = React.memo(
  ({
    fill = variables['colors-mc-primary'],
    width = '30',
    viewBox = '0 0 30 30',
    reverseOp = false
  }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <circle
        id='Ellipse_110'
        data-name='Ellipse 110'
        cx='15'
        cy='15'
        r='15'
        fill={fill}
        opacity={!reverseOp ? '0.1' : '1'}
      />
      <path
        id='Polygon_6'
        data-name='Polygon 6'
        d='M5.566.76a.5.5,0,0,1,.868,0l5.138,8.992a.5.5,0,0,1-.434.748H.862a.5.5,0,0,1-.434-.748Z'
        transform='translate(22 9) rotate(90)'
        fill={!reverseOp ? fill : variables['colors-mc-white']}
      />
    </svg>
  )
);
PlayIcon.displayName = 'PlayIcon';
export default PlayIcon;
